export const TERMINAL_TICKET_STATUSES = ['closed', 'resolved'] as const

export const isTerminalTicketStatus = (status: string): boolean =>
  (TERMINAL_TICKET_STATUSES as readonly string[]).includes(status)

export const patchTicketStatusInList = <T extends { id: string; status: string; status_label: string }>(
  tickets: T[],
  ticketId: string,
  updatedTicket: Pick<T, 'status' | 'status_label'>
): T[] =>
  tickets.map(ticket =>
    ticket.id === ticketId ? { ...ticket, status: updatedTicket.status, status_label: updatedTicket.status_label } : ticket
  )

export type TFollowUpSendResolution = {
  canSend: boolean
  markSending: boolean
  clearError: boolean
  markError: boolean
}

export const resolveTicketFollowUpSend = (socketOpen: boolean): TFollowUpSendResolution =>
  socketOpen
    ? { canSend: true, markSending: true, clearError: true, markError: false }
    : { canSend: false, markSending: false, clearError: false, markError: true }

export const shouldClearFollowUpDraft = (
  wasSending: boolean,
  isSending: boolean,
  hasFollowUpError: boolean
): boolean => wasSending && !isSending && !hasFollowUpError

export type TTicketHistoryErrorFollowUpResolution = {
  clearSending: boolean
  markFollowUpError: boolean
}

export const resolveTicketHistoryErrorDuringFollowUp = (
  isSendingFollowUp: boolean
): TTicketHistoryErrorFollowUpResolution => ({
  clearSending: isSendingFollowUp,
  markFollowUpError: isSendingFollowUp
})
